import { stock } from '@/data/stockImages';

// Karşılaştırma / seçim (B). Hedef: kafe yönetim sistemi seçimi, restoran yönetim programı seçerken dikkat edilecekler.
export default [
  {
    t: 'p',
    text: 'Kafe ya da restoran yönetim programı seçerken bakılması gereken beş konu var: işletmenizin günlük işlerini gerçekten karşılayıp karşılamadığı, hangi cihazlarda çalıştığı, toplam maliyeti, verilerinizin nerede ve nasıl tutulduğu ve bir sorun olduğunda nasıl destek alacağınız. Tanıtım sayfalarındaki özellik listeleri birbirine benzer; farkı, programı kendi menünüz ve kendi yoğun saatinizle denediğinizde görürsünüz.',
  },
  {
    t: 'p',
    text: 'Bu yazı, karar vermeden önce sağlayıcılara sorabileceğiniz soruları ve cevapları nasıl değerlendireceğinizi topluyor. Otomasyon sisteminin parçaları için [kafe ve restoran otomasyon sistemi nedir](/blog/kafe-restoran-otomasyon-sistemi-nedir), Türkiye’deki sağlayıcı türleri için [Türkiye’de restoran teknoloji şirketleri](/blog/turkiyede-restoran-teknoloji-sirketleri) yazısına bakabilirsiniz.',
  },
  { t: 'h2', text: 'Önce kendi ihtiyacınızı yazın' },
  {
    t: 'p',
    text: 'Program karşılaştırmaya başlamadan önce işletmenizin nasıl çalıştığını birkaç maddede yazmak, gereksiz özelliklere para ödemenizi ve ihtiyacınız olan bir özelliği atlamanızı önler:',
  },
  {
    t: 'list',
    items: [
      'Masa servisi mi, tezgâhtan satış mı, yoksa ikisi birden mi?',
      'Kaç masa, kaç çalışan ve kaç şube var? Yakın zamanda yeni şube açma planı var mı?',
      'Mutfak ve bar ayrı mı? Siparişin farklı kişilere yönlendirilmesi gerekiyor mu?',
      'Stok ve maliyeti takip etmek istiyor musunuz, yoksa şimdilik yalnızca sipariş ve hesap mı?',
      'QR menü ve sadakat programı planınızda var mı?',
    ],
  },
  { t: 'h2', text: 'Kontrol listesi' },
  {
    t: 'table',
    head: ['Konu', 'Neden önemli?', 'Sorulacak soru'],
    rows: [
      [
        'Cihaz',
        'Her garsona tablet almak ciddi bir ek maliyettir',
        'Garsonlar kendi telefonlarından kullanabilir mi? iOS ve Android uygulaması var mı?',
      ],
      [
        'Eş zamanlılık',
        'Mutfak, kasa ve salon aynı bilgiyi görmeli',
        'Bir cihazda girilen sipariş diğerlerinde ne kadar sürede görünür?',
      ],
      [
        'Yetkiler',
        'Garsonun iptal, indirim ya da rapor ekranına erişimi sınırlı olmalı',
        'Rol bazında yetki verilebiliyor mu?',
      ],
      [
        'Modüller',
        'QR menü, stok ve sadakat ayrı hizmetlerse veriler bölünür',
        'Bu modüller aynı sistemde mi, ek ücretli mi?',
      ],
      [
        'Şubeler',
        'Şube eklendiğinde yeni bir kurulum gerekmemeli',
        'Şubeler tek hesaptan ayrı ayrı yönetilebiliyor mu?',
      ],
      ['Raporlar', 'Gün sonu ve ay sonu ciroyu elle hesaplamamak için', 'Ürün bazında satış ve kâr raporu var mı?'],
      ['Destek', 'Yoğun saatte bir sorun satış kaybı demektir', 'Destek hangi kanaldan, hangi saatlerde veriliyor?'],
    ],
  },
  { t: 'h2', text: 'Bulut mu, yerel kurulum mu?' },
  {
    t: 'p',
    text: 'Yerel kurulumlu programlar işletmedeki bir bilgisayara kurulur, veriler orada tutulur. Bulut tabanlı programlar ise tarayıcıdan ya da uygulamadan açılır, veriler sağlayıcının sunucularında saklanır.',
  },
  {
    t: 'p',
    text: 'Bulut sistemlerin avantajı, işletme dışından da (evden, başka şubeden) erişilebilmesi, güncellemelerin kendiliğinden gelmesi ve bilgisayar arızalandığında verinin kaybolmamasıdır. Karşılığında internet bağlantısı gerekir. İnternetin sık kesildiği bir mekânda yedek bağlantı (örneğin bir mobil hat) düşünmek gerekir. Yerel kurulumda ise yedekleme, güncelleme ve donanım bakımı işletmenin sorumluluğundadır.',
  },
  { t: 'h2', text: 'Fiyatlandırma modelini doğru okuyun' },
  {
    t: 'img',
    img: stock('pos-tablet', 'Kasada tablet üzerinde çalışan yönetim programı'),
  },
  {
    t: 'p',
    text: 'Aylık ücret tek başına karşılaştırma için yeterli değildir. Bir yıllık toplam maliyeti hesaplarken şunları da sorun:',
  },
  {
    t: 'list',
    items: [
      '**Kurulum ücreti** var mı? Menünün sisteme girilmesi ücrete dahil mi?',
      '**Modül başına ücret** alınıyor mu? QR menü, stok ya da sadakat ayrıca mı ücretlendiriliyor?',
      '**Cihaz ya da kullanıcı başına ücret** var mı? Personel sayısı arttıkça fiyat değişiyor mu?',
      '**Yıllık bakım ya da güncelleme ücreti** var mı?',
      '**Taahhüt süresi** ne kadar? Erken ayrılmanın bir bedeli var mı?',
    ],
  },
  {
    t: 'p',
    text: 'Düşük aylık ücretli ama modül başına ücretlendirilen bir program, ihtiyaçlarınız büyüdükçe tek paketli bir programdan daha pahalıya gelebilir.',
  },
  { t: 'h2', text: 'Verileriniz ve müşteri bilgileri' },
  {
    t: 'p',
    text: 'Satış geçmişiniz, reçeteleriniz ve müşteri listeniz işletmenizin verisidir. Programı bırakmanız gerekirse bu verilere ne olacağını baştan sormak gerekir. Sadakat programı gibi müşteri bilgisi tutan modüllerde, verilerin nerede saklandığı ve KVKK kapsamındaki yükümlülüklerin nasıl karşılandığı da sağlayıcıya sorulması gereken konulardandır.',
  },
  { t: 'h2', text: 'Denemeden karar vermeyin' },
  {
    t: 'p',
    text: 'Demo sırasında sağlayıcının hazırladığı örnek menü yerine kendi menünüzden birkaç ürünü girmeyi isteyin. Bir masaya sipariş girip hesabı bölün, bir ürünü başka masaya aktarın, bir ürünün fiyatını değiştirip QR menüye yansımasına bakın. Mümkünse garsonlarınızdan birinin de denemesi, ekranın yoğun saatte ne kadar hızlı kullanılabileceğini gösterir.',
  },
  { t: 'h2', text: 'Tilki Otomasyon bu listede nerede duruyor?' },
  {
    t: 'p',
    text: 'Tilki bulut tabanlıdır; web paneli ve iOS/Android uygulamasıyla çalışır, garsonlar kendi telefonlarını kullanabilir. Masa ve sipariş, QR menü, stok ve maliyet, kampanya ve sadakat ile raporlar tek pakette gelir; aylık, 6 aylık ya da 12 aylık abonelikle, kurulum ve bakım ücreti olmadan sunulur. Personel rol bazında yetkilendirilir, destek talepleri panelden açılır. Güncel fiyat [fiyatlar sayfasında](/fiyatlar), sorularınız için [iletişim sayfası](/iletisim).',
  },
  {
    t: 'guide',
    image: '07-calisanlar',
    alt: 'Çalışanlar ekranında personel listesi ve rolleri',
    caption: 'Çalışanlar: her personel kendi rolü ve yetkisiyle.',
  },
  {
    t: 'cta',
    title: 'Kendi menünüzle deneyin',
    text: 'Ücretsiz demo talep edin; bu listedeki soruları kendi işletmeniz üzerinde birlikte cevaplayalım.',
    to: '/demo',
    label: 'Ücretsiz demo alın',
  },
];

export const faq = [
  {
    q: 'Restoran yönetim programı ile POS cihazı aynı şey mi?',
    a: 'Hayır. POS cihazı kartla ödeme almak için kullanılır. Yönetim programı ise siparişi, masaları, stoğu ve raporları yönetir. Bazı programlar POS cihazlarıyla entegre çalışır, ama biri diğerinin yerini tutmaz.',
  },
  {
    q: 'Programı değiştirirsem menümü baştan mı girmem gerekir?',
    a: 'Çoğu durumda ürünlerin yeni sisteme girilmesi gerekir. Geçiş öncesinde sağlayıcıya menü aktarımında yardım edip etmediğini sormak, bu süreyi kısaltır.',
  },
  {
    q: 'Tek şubeli bir kafe için çok şubeli bir program gereksiz mi?',
    a: 'Gereksiz değil, yeter ki fiyatı şube sayısına göre belirleniyor olsun. İleride şube açma ihtimaliniz varsa, baştan şube desteği olan bir programla başlamak sonradan veri taşıma ihtiyacını ortadan kaldırır.',
  },
];
